module.exports = function() {
  return new Worker(__webpack_public_path__ + "ce9117a8d92312f10982.worker.js");
};